import {
  type BlockTooltipAddOn,
  isLegacyTooltip,
  type TooltipPlacementPosition,
} from '@unifyapps/defs/blocks/common/tooltipTypes';

// icons saved before the tooltip add-on rework stored a flat shape instead of a
// BlockTooltipAddOn. the placement values are the same union as the new
// TooltipPlacementPosition, so they carry over as-is.
interface LegacyIconTooltip {
  text?: string;
  placement?: TooltipPlacementPosition;
  width?: string | { custom: string };
}

type IconTooltipValue = BlockTooltipAddOn & LegacyIconTooltip;

export function isLegacyIconTooltip(tooltip: IconTooltipValue | undefined): boolean {
  return isLegacyTooltip(tooltip) && typeof tooltip?.text === 'string';
}

/**
 * Maps a legacy `{ text, placement }` tooltip to the shared BlockTooltipAddOn so old
 * icons keep showing their tooltip. Legacy data is detected by a `text` field with no
 * new-shape `type`; anything already in the new shape is returned untouched.
 *
 * Note: the legacy `width` had no equivalent in the new architecture and is dropped.
 */
export function normalizeIconTooltip(
  tooltip: IconTooltipValue | undefined,
): BlockTooltipAddOn | undefined {
  if (!tooltip) return undefined;
  if (!isLegacyIconTooltip(tooltip)) return tooltip;

  return {
    type: 'text',
    content: tooltip.text,
    placementBehavior: 'manual',
    placementPosition: tooltip.placement ?? 'top',
  };
}
